// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* body {
  font-family: "Roboto", sans-serif;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f5f5, #eaeaea);
  align-items: center;
  padding: 0rem;
  text-align: center;
  flex-grow: 1;
}

.main-heading {
  font-size: 5rem !important;
  font-weight: 500 !important;
  color: #333;
  margin-bottom: 1.5rem;
  margin-top: 6rem !important;
  text-shadow: 1px 2px rgba(0, 0, 0, 0.1);
}

.login-button {
  padding: 0.6rem 1.5rem !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  border-radius: 6px !important;
  margin-bottom: 1rem !important;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1) !important;
  transition: transform 0.3s ease, box-shadow 0.3s ease !important;
  max-width: 200px;
  width: auto;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem !important;
}

.sub-heading {
  margin-bottom: 3rem;
  font-weight: 500;
}

.cards-container {
  max-width: 1200px;
  width: 100%;
  margin-bottom: 5rem;
}

.feature-card {
  padding: 2rem;
  text-align: center;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: #fff;
  min-height: 250px;
}

.feature-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);
}

.feature-icon {
  font-size: 4rem;
  margin-bottom: 1rem;
  color: #3f51b5;
}

.card-text {
  margin-top: 0.5rem;
  color: #666;
}

footer {
  width: 100%;
  background: black;
  color: white;
  padding: 1.5rem 0;
  text-align: center;
  margin-top: auto;
}

@media (max-width: 768px) {
  .main-heading {
    font-size: 2.2rem !important;
  }
  .feature-icon {
    font-size: 3rem;
  }
}

@media (max-width: 480px) {
  .main-heading {
    font-size: 1.8rem !important;
  }
  .login-button {
    width: 80% !important;
    max-width: none;
    font-size: 0.95rem !important;
  }
  .feature-card {
    min-height: 220px;
  }
} */
/* ///////////////////Rishabbh */


.landing-wrapper {
  background-color: #ffffff;
}

.hero-container {
  padding: 5rem 1rem 4rem;
  background-color: #ffffff; /* white background */
}

.hero-topic {
  font-size: 0.9rem;
  color: var(--gray-600);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
}

.hero-heading {
  font-size: 2.8rem;
  font-weight: bold;
  color: var(--gray-600);
  margin-bottom: 1.4rem;
}

.hero-subtitle {
  font-size: 1rem;
  color: var(--gray-600);
  margin-bottom: 1.5rem;
}


.hero-logo {
  font-size: 2.2rem; /* bigger size */
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-weight: 800;

  background: linear-gradient(135deg, var(--primary-500), var(--primary-400));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

  margin-bottom: 1.2rem;
  display: inline-block;
  transition: transform 0.3s ease, text-shadow 0.3s ease;
}

.hero-logo:hover {
  transform: scale(1.05);
  text-shadow: 0 4px 12px rgba(30, 64, 175, 0.4);
}

.logo-infy {
  font-weight: 500;
}

.logo-hr {
  font-weight: 800;
}


/* ///////// Login button  */
.custom-login-button {
  display: inline-block;
  background: linear-gradient(135deg, var(--primary-400), var(--primary-500));
  color: white;
  padding: 12px 32px;
  border: none;
  border-radius: 16px;
  font-size: 1rem;
  font-weight: 600;
  text-decoration: none;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  transition: all 0.35s ease;
  text-align: center;
   margin-top: 2rem;
}

.custom-login-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);
  background: linear-gradient(135deg, var(--primary-500), var(--primary-400));
}



.hero-image {
  width: 100%;
  border-radius: 10px;
}

.about-section {
  background-color: #ffffff; /* white background */
  padding: 4rem 1rem;
}

.about-title {
  font-size: 1.5rem;
  font-weight: 700;
  color: #222222;
  margin-bottom: 1.2rem;
}

.about-text {
  font-size: 1.15rem;
  color: var(--gray-800);
  line-height: 1.5;
  padding-right: 1rem;
}

.social-icons svg {
  font-size: 1.5rem;
  margin-right: 1rem;
  color: var(--gray-600);
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.social-icons svg:hover {
  opacity: 0.7;
}

.blog-card {
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
  border: 1px solid var(--gray-200);
  transition: transform 0.3s ease;
}

.blog-card:hover {
  transform: translateY(-5px);
}

.blog-image {
  width: 100%;
  height: auto;
  display: block;
}

.blog-title {
  padding: 1rem;
  font-weight: 600;
  color: var(--gray-600);
}

.blog-description {
  margin-top: 0.5rem;
  color: #444;
  font-size: 0.9rem;
  line-height: 1.5;
  padding: 15px;
}

.logo-bar {
  width: 100%;
  padding: 1.2rem 2.4rem 0.5rem;
  display: flex;
  align-items: center;
  background-color: #ffffff;
  position: relative;
  z-index: 5;
}

.company-logo {
  height: 50px;
  object-fit: contain;
}

/* Responsive Logo */
@media (max-width: 768px) {
  .logo-bar {
    padding: 1rem 1.5rem 0.5rem;
  }

  .company-logo {
    height: 42px;
  }
}

@media (max-width: 480px) {
  .logo-bar {
    padding: 0.8rem 1rem 0.4rem;
  }

  .company-logo {
    height: 36px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LandingPage/LandingPage.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8GG;AACH,gCAAgC;;;AAGhC;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB,EAAE,qBAAqB;AAClD;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;;AAGA;EACE,iBAAiB,EAAE,gBAAgB;EACnC,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;;EAEhB,2EAA2E;EAC3E,6BAA6B;EAC7B,oCAAoC;;EAEpC,qBAAqB;EACrB,qBAAqB;EACrB,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;;AAGA,4BAA4B;AAC5B;EACE,qBAAqB;EACrB,2EAA2E;EAC3E,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,0CAA0C;EAC1C,0BAA0B;EAC1B,kBAAkB;GACjB,gBAAgB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;EAC1C,2EAA2E;AAC7E;;;;AAIA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,EAAE,qBAAqB;EAChD,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["/* body {\n  font-family: \"Roboto\", sans-serif;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n}\n\n.root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f5f5, #eaeaea);\n  align-items: center;\n  padding: 0rem;\n  text-align: center;\n  flex-grow: 1;\n}\n\n.main-heading {\n  font-size: 5rem !important;\n  font-weight: 500 !important;\n  color: #333;\n  margin-bottom: 1.5rem;\n  margin-top: 6rem !important;\n  text-shadow: 1px 2px rgba(0, 0, 0, 0.1);\n}\n\n.login-button {\n  padding: 0.6rem 1.5rem !important;\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  text-transform: uppercase !important;\n  border-radius: 6px !important;\n  margin-bottom: 1rem !important;\n  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1) !important;\n  transition: transform 0.3s ease, box-shadow 0.3s ease !important;\n  max-width: 200px;\n  width: auto;\n  margin-left: auto;\n  margin-right: auto;\n  margin-top: 1rem !important;\n}\n\n.sub-heading {\n  margin-bottom: 3rem;\n  font-weight: 500;\n}\n\n.cards-container {\n  max-width: 1200px;\n  width: 100%;\n  margin-bottom: 5rem;\n}\n\n.feature-card {\n  padding: 2rem;\n  text-align: center;\n  border-radius: 8px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  background: #fff;\n  min-height: 250px;\n}\n\n.feature-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.15);\n}\n\n.feature-icon {\n  font-size: 4rem;\n  margin-bottom: 1rem;\n  color: #3f51b5;\n}\n\n.card-text {\n  margin-top: 0.5rem;\n  color: #666;\n}\n\nfooter {\n  width: 100%;\n  background: black;\n  color: white;\n  padding: 1.5rem 0;\n  text-align: center;\n  margin-top: auto;\n}\n\n@media (max-width: 768px) {\n  .main-heading {\n    font-size: 2.2rem !important;\n  }\n  .feature-icon {\n    font-size: 3rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .main-heading {\n    font-size: 1.8rem !important;\n  }\n  .login-button {\n    width: 80% !important;\n    max-width: none;\n    font-size: 0.95rem !important;\n  }\n  .feature-card {\n    min-height: 220px;\n  }\n} */\n/* ///////////////////Rishabbh */\n\n\n.landing-wrapper {\n  background-color: #ffffff;\n}\n\n.hero-container {\n  padding: 5rem 1rem 4rem;\n  background-color: #ffffff; /* white background */\n}\n\n.hero-topic {\n  font-size: 0.9rem;\n  color: var(--gray-600);\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n}\n\n.hero-heading {\n  font-size: 2.8rem;\n  font-weight: bold;\n  color: var(--gray-600);\n  margin-bottom: 1.4rem;\n}\n\n.hero-subtitle {\n  font-size: 1rem;\n  color: var(--gray-600);\n  margin-bottom: 1.5rem;\n}\n\n\n.hero-logo {\n  font-size: 2.2rem; /* bigger size */\n  letter-spacing: 1.5px;\n  text-transform: uppercase;\n  font-weight: 800;\n\n  background: linear-gradient(135deg, var(--primary-500), var(--primary-400));\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n\n  margin-bottom: 1.2rem;\n  display: inline-block;\n  transition: transform 0.3s ease, text-shadow 0.3s ease;\n}\n\n.hero-logo:hover {\n  transform: scale(1.05);\n  text-shadow: 0 4px 12px rgba(30, 64, 175, 0.4);\n}\n\n.logo-infy {\n  font-weight: 500;\n}\n\n.logo-hr {\n  font-weight: 800;\n}\n\n\n/* ///////// Login button  */\n.custom-login-button {\n  display: inline-block;\n  background: linear-gradient(135deg, var(--primary-400), var(--primary-500));\n  color: white;\n  padding: 12px 32px;\n  border: none;\n  border-radius: 16px;\n  font-size: 1rem;\n  font-weight: 600;\n  text-decoration: none;\n  cursor: pointer;\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n  transition: all 0.35s ease;\n  text-align: center;\n   margin-top: 2rem;\n}\n\n.custom-login-button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.25);\n  background: linear-gradient(135deg, var(--primary-500), var(--primary-400));\n}\n\n\n\n.hero-image {\n  width: 100%;\n  border-radius: 10px;\n}\n\n.about-section {\n  background-color: #ffffff; /* white background */\n  padding: 4rem 1rem;\n}\n\n.about-title {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #222222;\n  margin-bottom: 1.2rem;\n}\n\n.about-text {\n  font-size: 1.15rem;\n  color: var(--gray-800);\n  line-height: 1.5;\n  padding-right: 1rem;\n}\n\n.social-icons svg {\n  font-size: 1.5rem;\n  margin-right: 1rem;\n  color: var(--gray-600);\n  cursor: pointer;\n  transition: opacity 0.3s ease;\n}\n\n.social-icons svg:hover {\n  opacity: 0.7;\n}\n\n.blog-card {\n  border-radius: 10px;\n  overflow: hidden;\n  background: #ffffff;\n  border: 1px solid var(--gray-200);\n  transition: transform 0.3s ease;\n}\n\n.blog-card:hover {\n  transform: translateY(-5px);\n}\n\n.blog-image {\n  width: 100%;\n  height: auto;\n  display: block;\n}\n\n.blog-title {\n  padding: 1rem;\n  font-weight: 600;\n  color: var(--gray-600);\n}\n\n.blog-description {\n  margin-top: 0.5rem;\n  color: #444;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  padding: 15px;\n}\n\n.logo-bar {\n  width: 100%;\n  padding: 1.2rem 2.4rem 0.5rem;\n  display: flex;\n  align-items: center;\n  background-color: #ffffff;\n  position: relative;\n  z-index: 5;\n}\n\n.company-logo {\n  height: 50px;\n  object-fit: contain;\n}\n\n/* Responsive Logo */\n@media (max-width: 768px) {\n  .logo-bar {\n    padding: 1rem 1.5rem 0.5rem;\n  }\n\n  .company-logo {\n    height: 42px;\n  }\n}\n\n@media (max-width: 480px) {\n  .logo-bar {\n    padding: 0.8rem 1rem 0.4rem;\n  }\n\n  .company-logo {\n    height: 36px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
